import React, { useRef, useEffect, useState } from 'react';
import { GroupMessage } from '.';
import { VenueRequestComment } from '@go-shared/types/groupBooking';
import { User } from '@go-shared/types/user';
import { BubbleButton, BubbleTextArea } from './BubbleUI';

export interface GroupRequestFormBodyProps {
  loggedUser: User;
  comments: VenueRequestComment[];
  onRequestComment: (message: string) => void;
}

// this component only works on fixed heights
export default function GroupRequestFormBody(props: GroupRequestFormBodyProps) {
  const { loggedUser, comments, onRequestComment } = props;

  let [message, setMessage] = useState('');
  let messagesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let el = messagesRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight - el.clientHeight;
    }
  });

  return (
    <div className="GroupComments h-full flex flex-col">
      <div className="flex-grow relative">
        <div className="absolute top-0 left-0 w-full h-full overflow-y-auto flex flex-col-reverse">
          <div ref={messagesRef} className="bg-grey-lightest">
            {[...comments]
              .filter(c => c.message)
              .map((c, i) =>
                c.user._id === loggedUser._id ? (
                  <GroupMessage key={i} dark comment={c} position="right" />
                ) : (
                  <GroupMessage key={i} comment={c} position="left" />
                )
              )}
          </div>
        </div>
      </div>
      <div className="w-full flex items-center bg-white border-t" style={{ zIndex: 1 }}>
        <BubbleTextArea
          className="flex-grow"
          appearance="bare"
          value={message}
          placeholder="Type your message here..."
          textAreaClassName="px-3 py-2"
          onValue={setMessage}
        />
        <BubbleButton
          inverse
          onClick={() => {
            if (message.length === 0) return;
            onRequestComment(message);
            setMessage('');
          }}
          variant="lime"
          disabled={message.length === 0}
          icon="comment-arrow-up"
          iconSize="xl"
        />
      </div>
    </div>
  );
}
